<script lang="ts">
    import type HTMLSanitizerInterface from "@modules/money/HTMLSanitizer/HTMLSanitizerInterface";
    import { map } from "rxjs";

    import type RewardsCurrencyFormatter from "../lib/RewardsCurrencyFormatter";

    //Props
    export let amount: number;
    export let currencyFormatter: RewardsCurrencyFormatter;
    export let sanitizer: HTMLSanitizerInterface;

    const escapedFormatted$ = currencyFormatter
        .selectFormattedCurrency(amount)
        .pipe(
            map((formattedCurrency) => {
                return sanitizer.sanitize(formattedCurrency);
            })
        );
</script>

<slot amount={$escapedFormatted$}>
    {@html $escapedFormatted$}
</slot>
